import React from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'
import styled from 'styled-components'
import Colors from '../../assets/styles/Colors'
import Responsive from '../../assets/config/Responsive'

const TextArea: React.FC<{
  id: string
  label: string
  placeholder?: string
  value?: any
  required?: boolean
  error?: boolean
  errorText?: string
  className?: string
  onChange?: (value: any) => void
  style?: React.CSSProperties
  width?: 'fullWidth' | 'default'
  children?: React.ReactNode
  name?: string
  icon?: boolean
  onBlur?: (value: any) => void
  disabled?: boolean
  onKeyPress?: (value: any) => void
  formRegistration?: UseFormRegisterReturn
}> = ({
  id,
  label = '',
  placeholder,
  value,
  required,
  error = false,
  errorText,
  className,
  onChange,
  style,
  width = 'default',
  children,
  name,
  icon = false,
  onBlur,
  disabled = false,
  onKeyPress,
  formRegistration,
}) => {

  return (
    <Wrapper style={style} className={className} $width={width}>
      {label ? (
        <LabelStyle $error={error} htmlFor={`field-${id}`}>
          {label}
        </LabelStyle>
      ) : null}
      <TextAreaStyle
        $error={error}
        required={required}
        value={value}
        id={`field-${id}`}
        name={name}
        placeholder={placeholder}
        onChange={(event) => onChange?.(event.target.value)}
        onBlur={onBlur}
        disabled={disabled}
        onKeyPress={onKeyPress}
        {...formRegistration}
      />
      {error === true ? (
        <ErrorMessage $error={error} className={`field-${id}`}>
          {errorText}
        </ErrorMessage>
      ) : null}
    </Wrapper>
  )
}

export default TextArea

const Wrapper = styled.div<{$width: string}>`
  /* styles from props */
  width: ${({ $width }) => ($width === 'fullWidth' ? '100%' : '400px')};
  user-select: none;
  position: relative;
`
const ErrorMessage = styled.div<{ $error: boolean }>`
  width: inherit;
  font-size: 14px;
  line-height: 16px;
  text-align: left;
  color: ${({ $error }) => ($error === true ? `${Colors.primaryRed}` : `${Colors.primaryGrey}`)};
  margin-top: 5px;
`

const LabelStyle = styled.label<{ $error: boolean }>`
  width: inherit;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 5px;
  text-align: left;
  padding-right: 25px;
  color: ${({ $error }) => ($error === true ? `${Colors.primaryRed}` : `${Colors.primaryGrey}`)};
`
const TextAreaStyle = styled.textarea<{ $error: boolean }>`
  resize: none;
  width: inherit;
  outline: none;
  padding: 15px 22px;
  font-size: 14px;
  line-height: 16px;
  border: 1px solid ${Colors.secondaryGrey};
  border-color: ${({ $error }) => ($error === true ? `${Colors.primaryRed}` : `${Colors.secondaryGrey}`)};
  border-radius: 4px;
  background-color: ${Colors.white};
  color: ${Colors.primaryBlack};
  max-height: 65px;  
  /* focus stlyes */
  &:focus {
    border-color: ${({ $error }) => ($error === true ? `${Colors.primaryRed}` : `${Colors.rollingStone}`)};
  }

  /* responsive */
  ${Responsive.mobile} {
    padding: 15px 18px;
  }
`